import { createContext } from 'react';

/**
 * The picked computer, or the explicit "no computer" marker, or nothing yet.
 * Declared here rather than imported: it is structurally equal to rpa's
 * `DesktopTargetSticky`, whose sentinel is a string like any other.
 */
export type DesktopTargetSticky = string | null;

export type ViewSelection = {
  override: DesktopTargetSticky;
  setOverride: (value: DesktopTargetSticky) => void;
  carryToProject: (projectId: string) => void;
  reset: () => void;
};

export const DesktopTargetViewSelectionContext = createContext<ViewSelection | null>(
  null
);
